import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MainFont from '../../typography/mainFont';
import { ButtonCloseLead, ButtonContainer, CloseLeadContainer } from './style';
import Button from 'ui/atoms/Button';

const CloseLeadCreation = ({ leadClose, reloadCreate }) => {
  const { t } = useTranslation();

  return (
    <CloseLeadContainer>
      <MainFont
        configuration={{
          fontSize: 24,
          fontWeight: 600,
          lineHeight: 1.33
        }}
      >
        {t('hey_wait')}
      </MainFont>
      <MainFont
        configuration={{ fontSize: 16, lineHeight: 2, textAlign: 'center' }}
      >
        {t('lead_add_b2c')}
      </MainFont>
      <ButtonContainer>
        <ButtonCloseLead>
          <Button variant="popupCancelLead" onClick={reloadCreate}>
            {t('no_wait')}
          </Button>
        </ButtonCloseLead>
        <ButtonCloseLead>
          <Button variant="popupYesLead" onClick={leadClose}>
            {t('yes_close')}
          </Button>
        </ButtonCloseLead>
      </ButtonContainer>
    </CloseLeadContainer>
  );
};

CloseLeadCreation.propTypes = {
  leadClose: PropTypes.func,
  reloadCreate: PropTypes.func
};
export default connect(null, null)(CloseLeadCreation);
